"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var ExportHandlerEventStatus;
(function (ExportHandlerEventStatus) {
    ExportHandlerEventStatus[ExportHandlerEventStatus["None"] = 0] = "None";
    ExportHandlerEventStatus[ExportHandlerEventStatus["Waiting"] = 1] = "Waiting";
    ExportHandlerEventStatus[ExportHandlerEventStatus["Downloading"] = 2] = "Downloading";
    ExportHandlerEventStatus[ExportHandlerEventStatus["Complete"] = 3] = "Complete";
})(ExportHandlerEventStatus || (ExportHandlerEventStatus = {}));
var ExportHandler = /** @class */ (function (_super) {
    __extends(ExportHandler, _super);
    function ExportHandler(props) {
        var _this = _super.call(this, props) || this;
        _this.handleExport = function (exportRequest) {
            if (_this.state.status != ExportHandlerEventStatus.Waiting) {
                return;
            }
            _this.setState({
                status: ExportHandlerEventStatus.Downloading,
                secondsRemaining: 5
            }, function () {
                exportRequest.then(function (response) {
                    _this.setState({
                        url: response
                    });
                });
                var intervalId = setInterval(function () {
                    _this.setState({ secondsRemaining: _this.state.secondsRemaining - 1 }, function () {
                        if (_this.state.secondsRemaining == 0) {
                            if (_this.state.url != null || _this.state.url != undefined || _this.state.url != "") {
                                window.open(_this.state.url);
                                clearInterval(intervalId);
                                _this.setState({ status: ExportHandlerEventStatus.Complete }, function () {
                                    setTimeout(function () { _this.setState({ status: ExportHandlerEventStatus.Waiting }); }, 30000);
                                });
                            }
                            else {
                                _this.setState({ secondsRemaining: 5 });
                            }
                        }
                    });
                }, 1000);
            });
        };
        _this.state = {
            secondsRemaining: 5,
            url: "",
            status: ExportHandlerEventStatus.Waiting
        };
        return _this;
    }
    ExportHandler.prototype.render = function () {
        var _this = this;
        switch (this.state.status) {
            case ExportHandlerEventStatus.None:
            case ExportHandlerEventStatus.Waiting:
                return React.createElement("div", null);
            case ExportHandlerEventStatus.Downloading:
                return (React.createElement(reactstrap_1.Alert, { color: "primary" },
                    this.props.resources.DownloadStatus_1,
                    " ",
                    this.state.secondsRemaining,
                    " ",
                    this.props.resources.DownloadStatus_2));
            case ExportHandlerEventStatus.Complete:
                return (React.createElement(reactstrap_1.Alert, { color: "primary", toggle: function () { return _this.setState({ status: ExportHandlerEventStatus.Waiting }); } },
                    this.props.resources.DownloadNotStarted,
                    " ",
                    React.createElement("a", { href: this.state.url, className: "alert-link" }, this.props.resources.ClickHere_LowerCase),
                    "."));
        }
    };
    return ExportHandler;
}(React.Component));
exports.ExportHandler = ExportHandler;
//# sourceMappingURL=ExportHandler.js.map